import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { Company } from '../../../shared/models/missingdata.model';
import {  CompanyService} from '../../../shared/_services/company.service';

@Component({
  selector: 'app-table-company',
  templateUrl: './table-company.component.html',
  styleUrls: ['./table-company.component.css', '../admin-tables.component.css'],
  animations: [
    trigger('EnterLeave', [
      state('flyin', style({
        opacity: 1,
        transform: 'translateX(0%)'
      })),
      transition(':enter', [
        style({
          opacity: 0.2,
          transform: 'translateX(-100%)',
        }),
        animate('0.3s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          transform: 'translateX(100%)'
        }))
      ])
    ])
  ]
})
export class TableCompanyComponent implements OnInit {



  SearchTerm: string;
  List: Company[];
  NewElement: Company;
  saveElement: Company[] = [];
  FormNew = false;
  error: string;
  message: string;

  constructor(
    private branchService: CompanyService
  ) { }

  ngOnInit() {

    this.branchService.getCompany()
      .subscribe((lista: Company[]) => {
        this.List = lista;
      }, err => {
          this.error = err;
          setTimeout(() => {
            this.cleanMessage();
          }, 7000);
      })

  }

  cleanMessage() {
    this.message = undefined;
    this.error = undefined;
    this.saveElement = [];
  }

  onKeyUp(value) {
    this.SearchTerm = value;
  }

  changeValue(idBranch: any) {
    this.cleanMessage();
    let name = "[date-branch ='" + idBranch + "']";
    document.querySelectorAll(name).forEach(function (element) {
      element.removeAttribute("readonly");
    })
    document.getElementsByName("btgrnoffice-" + idBranch)[0].removeAttribute("hidden");

    document.getElementsByName("btednoffice-" + idBranch)[0].setAttribute("hidden", "hidden");
  }

  updateList(idBranch: any) {
    this.cleanMessage();
    let name = "[date-branch = '" + idBranch + "']";
    document.querySelectorAll(name).forEach(function (element) {
      element.setAttribute("readonly", "readonly");
    });

    //console.log(this.List.find(t => t.idOffice == idOffice));

    this.branchService.updateCompany(this.List.find(t => t.idConfig == idBranch))
      .subscribe(res => {
        document.getElementsByName("btednoffice-" + idBranch)[0].removeAttribute("hidden");
        document.getElementsByName("btgrnoffice-" + idBranch)[0].setAttribute("hidden", "hidden");
      }, err => this.error = err)
  }

}
